import { COLOR_OPTIONS, ColorStyle } from "components/select/lineUtility";
import type { FeatureStyleObject } from "types/firestoreFeatures";

/** Keep custom line colours consistent between the map and editor. */
export function getCustomLineColorId(styleObject?: FeatureStyleObject | null): ColorStyle {
  const color = COLOR_OPTIONS.find((option) => option.id === styleObject?.lineColor);
  return color ? color.id as ColorStyle : "White";
}
